import { render, staticRenderFns } from "./NotificationPopup.vue?vue&type=template&id=1d9043f3&scoped=true&"
import script from "./NotificationPopup.vue?vue&type=script&lang=ts&"
export * from "./NotificationPopup.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationPopup.vue?vue&type=style&index=0&id=1d9043f3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9043f3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCol,VIcon,VRow,VSnackbar})
